var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.localRecord
        ? [
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: { loading: true, color: _vm.loadingColor },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.localRecord
        ? _c("div", { staticClass: "text-left" }, [
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.localRecord && _vm.localRecord.id
                    ? "Обновить запись в черном списке"
                    : "Добавить запись в черный список"
                )
              ),
            ]),
            _vm._v(" "),
            _vm.localRecord
              ? _c(
                  "form",
                  { attrs: { action: "" }, on: { submit: _vm.addToList } },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Номер телефона"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.localRecord.phone_num,
                            expression: "localRecord.phone_num",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          disabled: !!_vm.localRecord.id,
                          placeholder: "+7 915 000 00 00",
                          type: "text",
                          required: "",
                        },
                        domProps: { value: _vm.localRecord.phone_num },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.localRecord,
                              "phone_num",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm.localRecord.comments
                      ? _c("div", { staticClass: "pb-2 card mb-1" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            _vm._l(
                              _vm.localRecord.comments,
                              function (comment, index) {
                                return _c(
                                  "div",
                                  {
                                    key: `comment_${index}`,
                                    staticClass: "comment",
                                  },
                                  [
                                    _c("p", [_vm._v(_vm._s(comment.text))]),
                                    _vm._v(" "),
                                    comment.drugs && comment.drugs.length
                                      ? [
                                          _c("hr"),
                                          _vm._v(" "),
                                          _vm._l(
                                            comment.drugs,
                                            function (drug) {
                                              return _c("p", [
                                                _vm._v(
                                                  _vm._s(drug && drug.title)
                                                ),
                                              ])
                                            }
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "author" }, [
                                      _vm._v(
                                        _vm._s(comment.user_name) +
                                          ": " +
                                          _vm._s(comment.created_at)
                                      ),
                                    ]),
                                  ],
                                  2
                                )
                              }
                            ),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.localRecord.id
                      ? _c("div", { staticClass: "p-2" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.localRecord.is_active,
                                  expression: "localRecord.is_active",
                                },
                              ],
                              attrs: { type: "checkbox", id: "ch_1" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.localRecord.is_active
                                )
                                  ? _vm._i(_vm.localRecord.is_active, null) > -1
                                  : _vm.localRecord.is_active,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.localRecord.is_active,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.localRecord,
                                          "is_active",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.localRecord,
                                          "is_active",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.localRecord, "is_active", $$c)
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "pl-2 pointer",
                                attrs: { for: "ch_1" },
                              },
                              [
                                _vm._v(
                                  "Запись активна, информация отображается в заявках"
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Комментарий"),
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.localRecord.comment,
                            expression: "localRecord.comment",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          required: !_vm.localRecord.id,
                          placeholder: "Комментарий",
                          rows: "3",
                        },
                        domProps: { value: _vm.localRecord.comment },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.localRecord,
                              "comment",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Добавить препараты"),
                        ]),
                        _vm._v(" "),
                        _vm.drugsSelected && _vm.drugsSelected.length
                          ? _c(
                              "div",
                              [
                                _vm._l(
                                  _vm.drugsSelected,
                                  function (drug, index) {
                                    return [
                                      drug
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex justify-content-between mb-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(drug.title) +
                                                  "\n              "
                                              ),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-sm btn-warning",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeDrug(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Х")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("DrugSearchNew", {
                          ref: "drugSelect",
                          attrs: { onDrugSelect: _vm.onDrugSelect },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Записи")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }